import classNames from "classnames";
import { VisuallyHidden } from "react-aria";

import { ThreeDotLoader } from ".";

import styles from "./loading.module.scss";

export const LoadingOverlay = ({
    visuallyHiddenText,
    extraClass,
}: {
    visuallyHiddenText: string;
    extraClass?: string;
}) => {
    return (
        <div
            aria-live="polite"
            className={classNames({
                [styles.loadingOverlay]: true,
                [extraClass!]: extraClass,
            })}
        >
            <p>
                <VisuallyHidden>{visuallyHiddenText}</VisuallyHidden>
            </p>
            <ThreeDotLoader className={styles.loader} />
        </div>
    );
};
